'use client';
import { TreeSelect } from 'antd';
import { API } from 'data';
import { RestAPI } from 'scripts';
import { PaginationType } from 'types';
import { useEffect, useState } from 'react';
import { __PostFormLocationType } from '../../addPost.type';

function LocationSelectComp(props: {
    onChange?: (e: __PostFormLocationType[]) => void;
    className?: string;
    placeholder?: string;
    altOnChange: (e: __PostFormLocationType) => void;
    defaultValue?: { id: number; title: string }[];
    value?: __PostFormLocationType[];
}) {
    const [locations, setLocations] = useState<__PostFormLocationType[]>();

    useEffect(() => {
        locationLoad();
    }, []);

    const locationLoad = (selected?: number) => {
        return new Promise((resolve) => {
            const filters: any = { page_size: 250 };
            if (selected) filters.parent = selected;
            else filters.parent__isnull = true;
            RestAPI.get<PaginationType<__PostFormLocationType>>(API.location.list, filters)
                .then((res) => {
                    const newLocationsList = [...(locations ?? []), ...res.data.data];
                    const defaultLocation: __PostFormLocationType[] | undefined = props.defaultValue?.length
                        ? [{ ...props.defaultValue[0], is_selectable: true }]
                        : undefined;
                    if (defaultLocation)
                        setLocations(
                            newLocationsList
                                .concat(defaultLocation)
                                .filter((v, i, a) => a.map((v) => v.id).indexOf(v.id) === i),
                        );
                    else setLocations(newLocationsList);
                    resolve(true);
                })
                .catch(() => resolve(false));
        });
    };

    return (
        <TreeSelect
            popupMatchSelectWidth={false}
            loadData={(e: any) => locationLoad(e.id)}
            treeDataSimpleMode
            className={props.className}
            placeholder={props.placeholder}
            allowClear
            showSearch={false}
            onSelect={(e) => {
                const loc = locations?.find((i) => i.id.toString() === e.toString());
                props.onChange?.(loc ? [loc] : []);
                if (loc) props.altOnChange(loc);
            }}
            value={props.value?.map((i) => i.id.toString())}
            treeExpandAction="click"
            treeData={locations
                ?.sort((a, b) => a.title.localeCompare(b.title))
                .map((item) => ({
                    id: item.id,
                    pId: item.parent?.id,
                    value: item.id.toString(),
                    title: item.title,
                    isLeaf: item.is_selectable,
                    selectable: item.is_selectable,
                }))}
        />
    );
}

export default LocationSelectComp;
